















import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BackToTopButton extends Vue {
  show = false;

  options = {
    duration: 250,
    easing: (t: number) => t * (2 - t)
  };

  onScroll(e: any) {
    if (typeof window === 'undefined') return;
    const top = window.pageYOffset || e?.target?.scrollTop || 1;
    this.show = top > 20;
  }
}
